var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheque1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 30,
    height: 30,
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    id: "Money_x5F_order",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 12.389,
    x: 77.682,
    y: 413.656
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 142.744,
    x: 199.375,
    y: 292.037
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 11.437,
    x: 177.854,
    y: 292.037
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 93.387,
    x: 177.854,
    y: 344.586
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 18.423,
    x: 323.696,
    y: 318.313
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 132.956,
    x: 177.854,
    y: 318.313
  }), /*#__PURE__*/React.createElement("rect", {
    height: 36.338,
    width: 10,
    x: 401.283,
    y: 297.037
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.283,231.856 48.383,231.856 48.383,404.488 339.578,404.488 339.578,394.488 58.383,394.488 58.383,241.856      401.283,241.856 401.283,282.512 411.283,282.512    "
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "60.542,172.695 66.787,201.901 76.566,199.81 72.412,180.382 447.232,100.214 473.052,220.925 431.016,229.917     431.016,212.688 300.749,212.688 386.679,194.311 384.587,184.532 252.932,212.688 100.46,212.688 96.632,194.802     431.942,123.083 440.446,162.844 450.226,160.752 439.63,111.213 84.762,187.115 90.234,212.688 27.713,212.688 27.713,423.656     64.341,423.656 64.341,413.656 37.713,413.656 37.713,222.688 421.016,222.688 421.016,346.122 359.133,346.122 359.133,391.885     369.133,391.885 369.133,356.122 414.652,356.122 361.934,413.656 102.935,413.656 102.935,423.656 366.334,423.656     431.016,353.066 431.016,240.142 468.796,232.061 437.293,284.705 445.873,289.84 484.287,225.647 454.92,88.344   "
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10.001,
    transform: "matrix(0.2091 0.9779 -0.9779 0.2091 547.0907 -288.9334)",
    width: 36.337,
    x: 434.008,
    y: 188.769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.935,313.182h-0.349v-20.908h20.617v-10h-20.617V262.07h-10v20.203h-0.481c-11.467,0-20.798,9.176-20.798,20.453    c0,11.279,9.331,20.455,20.798,20.455h0.481v22.27H85.141v10h21.445v18.823h10v-18.823h0.349c11.852,0,21.493-9.481,21.493-21.135    C138.428,322.662,128.786,313.182,116.935,313.182z M106.104,313.182c-5.954,0-10.798-4.689-10.798-10.455    c0-5.764,4.844-10.453,10.798-10.453h0.481v20.908H106.104z M116.935,345.451h-0.349v-22.27h0.349    c6.337,0,11.493,4.995,11.493,11.135S123.271,345.451,116.935,345.451z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheque1);
export default __webpack_public_path__ + "static/media/cheque1.2947626350e09412d757d950f6cb0b4b.svg";
export { ForwardRef as ReactComponent };